<template>
<div class="c-filters-wrapper o-grid">
    <div class="o-grid__column" data-size="sm:12 md:12 lg:3" data-layout="spacious">
		<div class="t-margin--1-bottom-half">
			<template v-for="(filter, index) in multiSelectFilters">
				<v-multi-select :key="`multiselect-${index}`" v-if="filter && filter.items && filter.items.length > 0" :label="filter.displayName" :id="filter.name" :options="filter.items" @optionSelected="setMultiSelectFilter"></v-multi-select>
			</template>
		</div>
		<div>
			<template v-for="(filter, index) in rangeFilters">
				<v-range-slider :key="`range-${index}`" :ariaLabelMax="filter.ariaLabelMax" :ariaLabelMin="filter.ariaLabelMin" :label="filter.displayName" :id="filter.name" :min-value="filter.minValue" :max-value="filter.maxValue" :selected-min="filter.selectedMin" :selected-max="filter.selectedMax" :step="1" @rangeSelected="setRangeFilter"></v-range-slider>
			</template>
		</div>
		<a href="#" class="t-reset-link" :style="`visibility: ${(filtersApplied) ? 'visible' : 'hidden'}`" @click.prevent="resetAllFilters">{{resetAllText}}</a>
    </div>
	<div class="o-grid__column t-display--md-up" data-size="md:12 lg:9" data-layout="spacious">
		<v-map :objects="objects" next-content="utilities"></v-map>
	</div>
</div>
</template>

<script>
import VMultiSelect from '../../components/form-elements/multi-select/VMultiSelect.vue';
import VRangeSlider from '../../components/form-elements/range-slider/VRangeSlider.vue';
import VMap from '../../components/map/map/VMap.vue';
export default {
    name: 'VFiltersWrapper',
    components: {
        VMultiSelect, VRangeSlider, VMap
    },
    props: {
        objects: {
            type: Array,
            default: () => []
        },
		multiSelectFilters: {
			type: Array,
			default: () => []
		},
		rangeFilters: {
			type: Array,
			default: () => []
		},
		filtersApplied: {
			type: Boolean,
			default: false
		},
		resetAllText: {
			type: String,
			default: 'Återställ val'
		},
    },
	methods: {
		setMultiSelectFilter(filter) {
			this.$emit('setMultiSelectFilter', filter);
		},
		setRangeFilter(filter) {
			this.$emit('setRangeFilter', filter);
		},
		resetAllFilters() {
			this.$emit('resetAllFilters');
		},
    },
}
</script>
